module.exports = __webpack_public_path__ + "img/undraw_Messages_re_qy9x (1).218a4295.svg";